module.exports = __webpack_public_path__ + "static/img/home-top-hero.e439e809.jpg";